export function InternalError(status, code, message) {
  this.status = status;
  this.code = code;
  this.message = message;
  this.name = this.constructor.name;
}

InternalError.prototype = _.create(Error.prototype);


export default function parseError(response) {
  if (response instanceof InternalError) {
    return Promise.reject(parseInternalError(response));
  }

  return Promise.reject(parseNativeError(response));
}


function parseNativeError(response) {
  const { status, error, data = {} } = response;

  if (error) {
    return response;
  }

  const { error: { code, errors } } = data;

  const message = _(errors)
    .map(error => `${error.reason}: ${error.message}`)
    .join(';\n');

  return {
    status,
    error: {
      code,
      message,
    },
  };
}


function parseInternalError({ status, code, message } = {}) {
  return {
    status,
    error: {
      code,
      message,
    },
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/parsers/error.js